import { IGraphQLResponse } from "@/types/graphql"
import { getCollectionSpecificFields } from "./fetchDataFromPayload"
import { Case, Individualprofile, Publicprofile } from "@/payload-types"

const caseDataFields = `
    id
    slug
    title
    type
    date
    coverimage{
        id
        mimeType
        title
        originalUrl
        source{
            title
            platform
        }
        handle
        sizes{
            webp{
                url
            }
            thumbnail{
                url
            }
            medium{
                url
            }
        }
    }
    universities{
        name
        slug
        _status
    }
    organizations{
        name
        publicOrgProfile{
            slug
            _status
        }
    }
    address
    profiles{
        publicProfile{
            slug
        }
    }
    topMedias{
        id
        title
        mimeType
        belongToCase{
            id
        }
        originalUrl
        source{
            title
            platform
        }
        handle
        coverImage{
            sizes{
                large{
                    url
                }
                webp{
                    url
                }
                thumbnail{
                    url
                }
                medium{
                    url
                }
            }
        }
        url
        sizes{
            large{
                url
            }
            thumbnail{
                url
            }
            webp{
                url
            }
            medium{
                url
            }
        }
        mux{
            assetId
            playbackId
            status
        }
    }
    shortDescription
    siblingCases{
        title
        slug
        date
        type
        address
        coverimage{
            sizes{
                thumbnail{
                    url
                }
            }
        }
    }
`
const profileDataFields = `
  profileEntity {
    id
    fullName
    isFromArtho
    medias {
      title
      mimeType
      belongToCase {
        id
      }
      sizes {
        medium {
          url
        }
      }
    }
  }
  slug
  _status
  profileImage {
    sizes {
      webp {
        url
      }
    }
  }
`;
const featuredIncidentsFields = `
    id
    title
    slug
    date
    type
    coverimage{
        sizes{
            thumbnail{
                url
                width
                height
            }
        }
    }
`



export function formatDate(dateString?: string | null): string {
    if (!dateString) return ''
    const date = new Date(dateString);

    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

export function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


export async function getCaseData(caseSlug: string, isDraft: boolean) {
    const data =
        (await getCollectionSpecificFields(
            'Cases',
            caseDataFields,
            `slug: { equals: "${caseSlug}"} `,
            1,
            isDraft,
        )) as IGraphQLResponse<Case, 'Cases'>
        const profileSlugs = data.Cases.docs[0]?.profiles
  ?.map((profile: any) => profile.publicProfile?.slug)
  .filter(Boolean);

const slugList = profileSlugs?.map((slug: string) => `"${slug}"`).join(', ');

const profileData = await getCollectionSpecificFields(
  'Publicprofiles',
    profileDataFields,
    `_status: { equals: published }, slug: { in: [${slugList}] }`,
  ) as IGraphQLResponse<Publicprofile, 'Publicprofiles'>;
  const individualProfilesInCase = profileData.Publicprofiles.docs.map((profile)=>{
    if(typeof profile.profileEntity === 'object'){
        const individualProfile = {
          id: profile.profileEntity?.id,
          fullName: profile.profileEntity?.fullName,
          medias: profile.profileEntity?.medias,
          isFromArtho: profile.profileEntity?.isFromArtho,
          createdAt: profile.profileEntity?.createdAt,
          updatedAt: profile.profileEntity?.updatedAt,
          publicProfile:{
            slug: profile.slug,
            _status: profile._status,
            profileImage: profile.profileImage,
          } as Publicprofile
        } as Individualprofile
        return individualProfile
    }
    return null
  })  
  return {
    ...data.Cases.docs[0],
    profiles: individualProfilesInCase as Individualprofile[]
  }
}

export const getFeaturedIncidents = async (caseId: string) => {
    const data =
        (await getCollectionSpecificFields(
            'Cases',
            featuredIncidentsFields,
            `, parentCases: { equals: "${caseId}"} `,
        )) as IGraphQLResponse<Case, 'Cases'>
    return data.Cases.docs
}